import React, { useEffect, useState } from "react";
import { Tabs, Spin } from "antd";
import SideBar from "../../components/sideBar/sideBar";
import EventAnalytics from "./EventAnalytics";
import AttendeeHistory from "./AttendeeHistory";
import Ratios from "./Ratios";
import CompanyAnalytics from "./CompanyAnalytics";
import EventComparison from "./EventComparison";
import JobTitles from "./JobTitles";
import EventSegmentation from "./EventSegmentation";

const Analytics = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Initial fetch if needed
    }, []);

    const items = [
        { key: "1", label: "Event Analytics", children: <EventAnalytics /> },
        { key: "2", label: "Attendee History", children: <AttendeeHistory /> },
        { key: "3", label: "Acceptance/Rejection Ratios", children: <Ratios /> },
        { key: "4", label: "Company View", children: <CompanyAnalytics /> },
        { key: "5", label: "Event Comparison", children: <EventComparison /> },
        { key: "6", label: "Job Titles Analytics", children: <JobTitles /> },
        { key: "7", label: "Scope / Region Segmentation", children: <EventSegmentation /> },
    ];

    return (
        <div className="flex bg-white h-screen">
            <div className="w-[18%] shadow-y shadow-right border-r-2 h-screen z-10">
                <SideBar selected={"9"} />
            </div>

            <div className="w-[82%] relative bg-slate-50 h-screen overflow-y-auto z-0 p-8">
                <div className="mb-6 flex justify-between items-center">
                    <div>
                        <h1 className="text-3xl font-bold font-Montserrat text-themeBlack">
                            Analytics & Reports
                        </h1>
                        <p className="text-gray-500 mt-1">
                            View event, attendee, and company level analytics.
                        </p>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center items-center h-[60vh]">
                        <Spin size="large" />
                    </div>
                ) : (
                    <div className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 min-h-[500px]">
                        <Tabs defaultActiveKey="1" items={items} className="custom-tabs" />
                    </div>
                )}
            </div>
        </div>
    );
};

export default Analytics;
